export default "__VITE_ASSET__zBEAW02Q__"